var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group uploader-box" }, [
    _vm.showAddButton
      ? _c(
          "label",
          {
            staticClass: "btn btn-main btn-rounded btn-sm mx-0",
            attrs: {
              title: "Adicionar ficheiro",
              "data-toggle": "tooltip-city",
            },
          },
          [
            _vm._t("button"),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.multiple ? "Ficheiros" : "Ficheiro") + " "),
              _c("i", { staticClass: "pl-1 fas fa-plus" }),
            ]),
            _vm._v(" "),
            _c("input", {
              ref: "inputFile",
              attrs: {
                type: "file",
                name: _vm.name,
                accept: _vm.acceptTypes,
                multiple: _vm.multiple,
              },
              on: { change: _vm.uploadFieldChange },
            }),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "d-flex flex-md-column flex-wrap d-sm-inline-flex flex-sm-nowrap",
      },
      [
        _vm.showList
          ? _vm._l(_vm.mutableValue, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "item",
                  class: { "pl-sm-3": _vm.showAddButton },
                },
                [
                  _vm.activeEdit
                    ? _c(
                        "div",
                        {
                          staticClass: "delete mr-3 d-inline",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.removeFileLoaded(index)
                            },
                          },
                        },
                        [_c("i", { staticClass: "fas fa-times" })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.linkToItem(item)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "far fa-file-alt d-inline" }),
                      _c("span", { staticClass: "d-inline" }, [
                        _vm._v(" - " + _vm._s(_vm.$t(item.name))),
                      ]),
                    ]
                  ),
                ]
              )
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.showHelp &&
        _vm.activeEdit &&
        (!_vm.mutableValue || _vm.mutableValue.length == 0)
          ? _c("small", { staticClass: "pl-sm-3" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    `Possivel adicionar no máximo ${_vm.maxFiles} ficheiros.`
                  ) +
                  "\n        "
              ),
            ])
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _vm.error
      ? _c("small", { staticClass: "d-block invalid-feedback" }, [
          _vm._v(_vm._s(_vm.error)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }